import React, { Component } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './download-widget.css';

export default class DownloadWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // "download_label": "Realizar Download",
      "download_label": "Aguarde, iniciando download...",
      "resume_download_label": "Retomar Download",
      "remove_download_label": "Remover Curso",
      "removing_download": false
    }
  }

  componentWillMount() {
    AOS.init({
      offest: -50
    });
  }

  componentDidUpdate() {
    const {
      progress
    } = this.props;

    this.checkIfDownloadRemoved()

    if (progress === 0 && this.state.remove_download_label === "Removendo Curso...") {
      this.setState({
        "remove_download_label": "Remover Curso"
      })
    }
  }

  componentDidMount() {
    // this.refreshDownload()
  }

  // refreshDownload() {
  //   var _this = this;
  //   window.downloadInterval = setInterval(function() {
  //     _this.onDownloadClick()
  //   }, 10000);
  // }

  onClose() {
    if (!this.state.removing_download) {
      // clearInterval(window.downloadInterval);
      this.props.onClose();
    }
  }


  formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
  }

  onDownloadClick() {
    // var progress = this.props.progress;
    // if (progress === 100) {
    //   clearInterval(window.downloadInterval);
    //   return;
    // };
    console.log("download dispatch")
    this.props.onDownload()
    this.setState({
      "download_label": "Aguarde, iniciando download...",
      "resume_download_label": "Realizando Download"
    })
  }

  onRemoveClick() {
    this.setState({
      "removing_download": true,
      "remove_download_label": "Removendo Curso..."
    })
    this.props.onRemove()
    this.awaitCloseWindow()
  }

  awaitCloseWindow() {
    var _this = this;
    setTimeout(function() {
      _this.props.onClose();
    }, 10000)
  }

  checkIfDownloadRemoved() {
    const { progress } = this.props;
    const { removing_download } = this.props;

    if (removing_download === true && progress === 0) {
      this.onClose()
    }
  }

  render() {
    const {
      removing_download
    } = this.state;
    const {
      progress = 0,
      downloadingLength = 0
    } = this.props;
    return <div className="rdp-react-template-component-download-widget">
      <div className="rdp-react-template-component-download-widget-overlay" onClick={() => this.onClose()}></div>
      <div className="rdp-react-template-component-download-widget-box" data-aos="fade-down" data-aos-duration="500">
        <div className="rdp-react-template-component-download-widget-box-header">
          <span className={`rdp-react-template-component-download-widget-box-header-back ${removing_download === true ? "inactive" : ""}`} onClick={() => this.props.onClose()}></span>
          <h1 className="rdp-react-template-component-download-widget-box-header-title">
            {progress === 0 && "Download do Curso"}
            {(progress > 0 && progress < 100) && "Realizando Download..."}
            {progress === 100 && "Curso Disponível Offline"}
          </h1>
        </div>
        <div className="rdp-react-template-component-download-widget-box-body">
          {(downloadingLength > 0 || progress > 0) && removing_download === false &&
            <>
              <div className="rdp-react-template-component-download-widget-box-progress">
                <div className="rdp-react-template-component-download-widget-box-progress-bar" style={{width: `${progress}%`}}></div>
              </div>
              <div className="rdp-react-template-component-download-widget-box-progress-texts">
                {/* <span className="rdp-react-template-component-download-widget-box-progress-text">{this.formatBytes(totalBytes / (100 / progress))} / {this.formatBytes(totalBytes)}</span> */}
                <span></span>
                <span className="rdp-react-template-component-download-widget-box-progress-text">{Math.round(progress)}%</span>
              </div>
            </>
          }

          {downloadingLength === 0 && progress === 0 && removing_download === false &&
            <div className="rdp-react-template-component-download-widget-box-preloader">
              <div className="rdp-react-template-view-login-preloader" style={{position: "relative"}}>
                <div className="rdp-react-template-view-login-preloader-loader"></div>
              </div>
              <span className="rdp-react-template-component-download-widget-box-message">
                Aguarde, iniciando download...
              </span>
            </div>
          }

          {removing_download === true &&
            <div className="rdp-react-template-component-download-widget-box-preloader">
              <div className="rdp-react-template-view-login-preloader" style={{position: "relative"}}>
                <div className="rdp-react-template-view-login-preloader-loader"></div>
              </div>
              <span className="rdp-react-template-component-download-widget-box-message">
                Aguarde, removendo download...
              </span>
            </div>
          }

          <div className="rdp-react-template-component-download-widget-box-actions">
            {/* {progress === 0 &&
              <button className="rdp-react-template-component-download-widget-box-action-btn download" onClick={() => this.onDownloadClick()}>
                {this.state.download_label}
              </button>
            }
            {(progress > 0 && progress < 100) &&
              <button className="rdp-react-template-component-download-widget-box-action-btn download" onClick={() => this.onDownloadClick()}>
                {this.state.resume_download_label}
              </button>
            } */}
            {progress === 100 && removing_download === false &&
              <button className="rdp-react-template-component-download-widget-box-action-btn remove" onClick={() => this.onRemoveClick()}>
                {this.state.remove_download_label}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  }
}
